import showLogger from '../showLogger'
import { dataObject } from '../../../../shared/types/data.type'
import { ApiConfig } from '..'
// import { getRefresh } from '../refreshToken'

export default function handleFailure(error: { response: dataObject; [key: string]: unknown }, apiInfo: ApiConfig, openUnAuthAlertMemo?: () => void) {
  showLogger(`${apiInfo.name}_FAILURE`, error, true)

  const goLogInPage = () => {
    //把錯誤處理的modal傳方式入可再優化
    openUnAuthAlertMemo && openUnAuthAlertMemo()
    window.localStorage.clear()
  }
  //if 24 hrs token overdue will get 401 and call refreshtoken api
  //if refresh token api get 401 or 403 need to redirect to login page
  if (!error.response) return Promise.reject(error)
  const isUnauthorized = error.response.status === 403 || error.response.status === 401

  if (isUnauthorized) {
    const refreshToken = window.localStorage.getItem('REFRESH_TOKEN')
    if (!refreshToken) {
      goLogInPage()
      return Promise.reject()
    } else {
      //先用fetch寫之後再優化
      //get refresh Token
      // return fetch(`http://10.1.1.38:8088/account/auth/token_refresh?refresh_token=${refreshToken}`, {
      return fetch(`https://api.dev.ci-btox.com/account/auth/token_refresh?refresh_token=${refreshToken}`, {
        method: 'get',
      })
        .then((res) => {
          if (res.ok) {
            return res.json()
          }
          return Promise.reject(res.json())
        })
        .then((data) => {
          const newAccessToken = data.result_data.access_token
          window.localStorage.setItem('ACCESS_TOKEN', newAccessToken)
          window.location.reload()
          return Promise.resolve(data)
        })
        .catch((err) => {
          goLogInPage()
          return Promise.reject(err)
        })
    }
  }

  return Promise.reject(error)
}
